module.exports = __webpack_public_path__ + "img/placeholder-white.7a7c76e0.svg";